var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"tit"},[_vm._v("#"),_c('strong',[_vm._v("botalab")]),_vm._v(" Instagram")]),_c('p',{staticClass:"sub-copy"},[_vm._v(" Share your moment and meet the light of INCELLDERM ")])])
}]

export { render, staticRenderFns }